import { InjectionToken } from '@angular/core';
import { PortalSettings } from '../types/base-portal-settings.type';

export const PORTAL_SETTINGS = new InjectionToken<PortalSettings>('PORTAL_SETTINGS');
